import React, { useState } from 'react'
import List from './Components/List'
import Create from './Components/Create'

export default function Exams() {
    const [is_edit, setIsEdit] = useState(false);
    const [edit_id, setEditId] = useState(0);
    const [is_reschedule, setIsReschedule] = useState(false);
    return (
        <>
            <div className="container-xxl flex-grow-1 container-p-y">
                <div className="row">
                    <div className="col-12 col-xl-12 col-sm-12 order-1 order-lg-2 mb-4 mb-lg-0">
                        <div className="d-flex justify-content-between align-items-center mb-2">
                            <button type="button" className="btn btn-outline-secondary btn-sm" onClick={() => { window.location.href = '/Admin/Dashboard'; }}>
                                Back
                            </button>
                            <p className='text-right mb-0'><small class="fw-bold py-3">Dashboard<span class="text-muted fw-light"> / Exams</span> </small></p>
                        </div>
                        <div className="card">
                            <div className="card-header d-flex justify-content-between align-items-center">
                                <h5 className='card-title mb-0'>Exams</h5>
                                <Create BTNLabel={"Add New Exam"} Header={is_edit ? is_reschedule ? "Reschedule Exam" : "Update Exam" : "Create Exam"} Subheader="" PopupID="Exams" is_edit={is_edit} setIsEdit={setIsEdit} edit_id={edit_id} setEditId={setEditId} is_reschedule={is_reschedule} setIsReschedule={setIsReschedule} />
                            </div>
                            <div className="card-datatable table-responsive">
                                <List PopupID="Exams" setIsEdit={setIsEdit} setEditId={setEditId} setIsReschedule={setIsReschedule} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
